import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Feed from './pages/Feed';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Search from './pages/Search';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import ProjectFiles from './pages/ProjectFiles';
import Messages from './pages/Messages';
import Notifications from './pages/Notifications';
import Suggestions from './pages/Suggestions';
import Legal from './pages/Legal';
import CookieBanner from './components/CookieBanner';
import Admin from './pages/Admin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import VerifyEmailPending from './pages/VerifyEmailPending';

function RequireVerified({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user.is_active === false) return <Navigate to="/verify-pending" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/verify-pending" element={<VerifyEmailPending />} />
          <Route path="/legal/:page" element={<Legal />} />
          <Route path="/" element={<RequireVerified><Feed /></RequireVerified>} />
          <Route path="/profile/:username" element={<RequireVerified><Profile /></RequireVerified>} />
          <Route path="/search" element={<RequireVerified><Search /></RequireVerified>} />
          <Route path="/projects" element={<RequireVerified><Projects /></RequireVerified>} />
          <Route path="/projects/:id" element={<RequireVerified><ProjectDetail /></RequireVerified>} />
          <Route path="/projects/:id/files" element={<RequireVerified><ProjectFiles /></RequireVerified>} />
          <Route path="/projects/:id/files/*" element={<RequireVerified><ProjectFiles /></RequireVerified>} />
          <Route path="/messages" element={<RequireVerified><Messages /></RequireVerified>} />
          <Route path="/messages/:conversationId" element={<RequireVerified><Messages /></RequireVerified>} />
          <Route path="/admin" element={<RequireVerified><Admin /></RequireVerified>} />
          <Route path="/notifications" element={<RequireVerified><Notifications /></RequireVerified>} />
          <Route path="/suggestions" element={<RequireVerified><Suggestions /></RequireVerified>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <footer style={{ textAlign: "center", padding: "20px", borderTop: "1px solid var(--border)", fontSize: "12px", color: "var(--muted)", background: "rgba(255,255,255,0.8)" }}>
          © 2026 Agora — GUERIN Maxime ·
          <Link to="/legal/cgu" style={{ color: "var(--blue)", margin: "0 6px" }}>CGU</Link> ·
          <Link to="/legal/confidentialite" style={{ color: "var(--blue)", margin: "0 6px" }}>Confidentialité</Link> ·
          <Link to="/legal/mentions" style={{ color: "var(--blue)", margin: "0 6px" }}>Mentions légales</Link>
        </footer>
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
